import { getSafeUserRequestContext, type ManagerPermissionName, type ManagerPermissions } from '#shared/lib/context';
import { hasPermission } from '#shared/lib/managerPermissions';
import { getMenuConfiguration } from './constants';
import { type MenuSection } from './types';

function filterMenuItemsByPermission<T extends { itemId: string; permission?: ManagerPermissionName }>(
    menuItems: T[],
    permissions: ManagerPermissions
): T[] {
    return menuItems.filter((item) => {
        const requiredPermission = item.permission;

        if (requiredPermission === undefined) {
            return true;
        }

        return hasPermission(permissions, requiredPermission, 'read');
    });
}

const filterMenuSectionsByPermission = (menuSections: MenuSection[], permissions: ManagerPermissions): MenuSection[] =>
    menuSections.map((section) =>
        filterMenuItemsByPermission(section, permissions).map((item) => {
            if (item.subMenuItems) {
                return {
                    ...item,
                    subMenuItems: filterMenuItemsByPermission(item.subMenuItems, permissions),
                };
            }

            return item;
        })
    );

export const getMenuSections = () => {
    const permissions = getSafeUserRequestContext().permissions ?? {};
    const { sidebarSections } = getMenuConfiguration();

    return filterMenuSectionsByPermission(sidebarSections, permissions);
};
